import { Avatar, ButtonBase } from '@mui/material';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  text: string;
  active: boolean;

  handleSelectedLinkedinAccountChange(): void;
}

const LinkedinAccountAvatar: React.FC<Props> = ({ text, active, handleSelectedLinkedinAccountChange }) => {
  const { classes, cx } = useStyles();

  return (
    <ButtonBase className={classes.avatarButton} onClick={handleSelectedLinkedinAccountChange}>
      <Avatar className={cx(classes.linkedinAccountAvatar, active ? 'active' : undefined)}>{text}</Avatar>
    </ButtonBase>
  );
};

const useStyles = makeStyles()((theme) => ({
  avatarButton: {
    borderRadius: '50%',
  },
  linkedinAccountAvatar: {
    width: '34px',
    height: '34px',
    fontSize: theme.typography.pxToRem(13),
    fontWeight: 700,
    cursor: 'pointer',
    border: '2px solid #FFF',
    background: '#B0A9FF',
    color: '#FFF',
    '&.active': {
      background: theme.palette.primary.main,
    },
  },
}));

export default LinkedinAccountAvatar;
